import client from '@/services/client'
import type {
  IFlowLabel,
  ILabelCreate,
  ILabelUpdate,
} from '@/types/flow/FlowLabelTypes'

import type { AxiosResponse } from 'axios'

const getAll = async (
  flowUuid: string
): Promise<AxiosResponse<IFlowLabel[]>> => {
  return await client.get<IFlowLabel[]>(`flows/${flowUuid}/labels`)
}

/**
 * Update indexes of labels for flow, order of uuids matters
 * @param {string} flowUuid
 * @param {Array<string>} labelsUuids
 */
const updateIndexes = async (
  flowUuid: string,
  labelsUuids: string[]
): Promise<AxiosResponse<IFlowLabel[]>> => {
  return await client.put<IFlowLabel[]>(`flows/${flowUuid}/label-indexes`, {
    labelUuids: labelsUuids,
  })
}

const create = async (
  label: ILabelCreate
): Promise<AxiosResponse<IFlowLabel>> => {
  return await client.post<IFlowLabel>(`flows/labels`, label)
}

const update = async (
  labelUuid: string,
  label: ILabelUpdate
): Promise<AxiosResponse<IFlowLabel>> => {
  return await client.patch<IFlowLabel>(`flows/labels/${labelUuid}`, label)
}

const destroy = async (labelUuid: string): Promise<AxiosResponse<void>> => {
  return await client.delete<void>(`flows/labels/${labelUuid}`)
}

export const FlowLabels = {
  getAll,
  updateIndexes,
  create,
  update,
  destroy,
}
